import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const MetaDataServiceConfig = {
  name: "MetaData",
  annotations: []
} as ServiceConfig;